var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_TouchpointSettings_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_TouchpointSettings_Delete_Body"
          ),
          brickTitle: _vm.resource(
            "JourneyComposer_BrickSettingsTouchpoint_Title"
          )
        },
        invalid: _vm.isLoading || _vm.$v.$invalid || !_vm.customConditionsValid,
        brick: _vm.brick,
        name: _vm.newName,
        "include-actionable-report-navigation": ""
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.save()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        },
        "display-errors": function($event) {
          return _vm.displayErrors()
        }
      }
    },
    [
      _c("settings-item", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsTouchpoint_ParentType_DisplayName"
          ),
          icon: "far fa-edit"
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      options: _vm.touchPointParentTypes,
                      disabled:
                        !_vm.canWrite || _vm.touchPointParentTypes.length === 0,
                      clearable: false,
                      searchable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.touchpointParentTypeModel,
                      callback: function($$v) {
                        _vm.touchpointParentTypeModel = $$v
                      },
                      expression: "touchpointParentTypeModel"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          },
          {
            key: "errors",
            fn: function() {
              return [
                _vm.$v.settings.touchpointParentType.$dirty &&
                _vm.$v.settings.touchpointParentType.$invalid
                  ? _c("required-error-message", {
                      attrs: {
                        "field-name": _vm.resource(
                          "JourneyComposer_BrickSettingsTouchpoint_ParentType_DisplayName"
                        )
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsTouchpoint_Type_DisplayName"
          ),
          icon: "far fa-edit"
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    ref: "subtype",
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      label: "name",
                      options: _vm.availableTouchPointTypes,
                      disabled:
                        !_vm.canWrite ||
                        _vm.availableTouchPointTypes.length === 0,
                      clearable: false,
                      searchable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.selectedTouchPointType,
                      callback: function($$v) {
                        _vm.selectedTouchPointType = $$v
                      },
                      expression: "selectedTouchPointType"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          },
          {
            key: "errors",
            fn: function() {
              return [
                _vm.$v.settings.touchPointTypeId.$dirty &&
                _vm.$v.settings.touchPointTypeId.$invalid
                  ? _c("required-error-message", {
                      attrs: {
                        "field-name": _vm.resource(
                          "JourneyComposer_BrickSettingsTouchpoint_Type_DisplayName"
                        )
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_BrickSettingsTouchpoint_Variation_DisplayName"
          ),
          icon: "far fa-edit"
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      label: "name",
                      "input-id": id,
                      options: _vm.availableVariationOptions,
                      disabled:
                        !_vm.canWrite ||
                        _vm.availableVariationOptions.length === 0,
                      clearable: "",
                      searchable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.touchpointVariationModel,
                      callback: function($$v) {
                        _vm.touchpointVariationModel = $$v
                      },
                      expression: "touchpointVariationModel"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.campaignType
        ? _c("touchpoint-campaign", {
            attrs: {
              label: _vm.campaignType.label,
              icon: _vm.campaignType.icon,
              options: _vm.campaignOptions
            },
            model: {
              value: _vm.settings.typeSettings[_vm.campaignType.propertyName],
              callback: function($$v) {
                _vm.$set(
                  _vm.settings.typeSettings,
                  _vm.campaignType.propertyName,
                  $$v
                )
              },
              expression: "settings.typeSettings[campaignType.propertyName]"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayGroupByTitle
        ? _c("settings-item", {
            attrs: {
              label: _vm.resource("JourneyBuilder_FilterSettings_GroupByTitle")
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("toggle", {
                        attrs: {
                          sync: true,
                          labels: {
                            checked: _vm.resource("Bool_Yes"),
                            unchecked: _vm.resource("Bool_No")
                          },
                          width: 78,
                          disabled: !_vm.canWrite
                        },
                        model: {
                          value: _vm.settings.typeSettings.groupByTitle,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settings.typeSettings,
                              "groupByTitle",
                              $$v
                            )
                          },
                          expression: "settings.typeSettings.groupByTitle"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2974059488
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayGoalToggleForTouchpointBricks
        ? _c("settings-item", {
            attrs: {
              label: _vm.resource(
                "JourneyBuilder_FilterSettings_Goal_DisplayName"
              )
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("toggle", {
                        attrs: {
                          sync: true,
                          labels: {
                            checked: _vm.resource("Bool_Yes"),
                            unchecked: _vm.resource("Bool_No")
                          },
                          width: 78,
                          disabled: !_vm.canWrite
                        },
                        model: {
                          value: _vm.settings.goal,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "goal", $$v)
                          },
                          expression: "settings.goal"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2468769330
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.touchPointTypes.length
        ? _c("touchpoint-custom-conditions", {
            ref: "customConditions",
            attrs: {
              "parent-type": _vm.settings.touchpointParentType,
              "sub-type":
                _vm.selectedTouchPointType && _vm.selectedTouchPointType.name
            },
            on: {
              "loading-state-changed": function($event) {
                _vm.isLoading = $event
              },
              "validation-state-changed": function($event) {
                _vm.customConditionsValid = $event
              }
            },
            model: {
              value: _vm.settings.customConditions,
              callback: function($$v) {
                _vm.$set(_vm.settings, "customConditions", $$v)
              },
              expression: "settings.customConditions"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("arrival", {
        attrs: { availableConditions: _vm.availableArrivalConditions },
        model: {
          value: _vm.settings.arrivalCondition,
          callback: function($$v) {
            _vm.$set(_vm.settings, "arrivalCondition", $$v)
          },
          expression: "settings.arrivalCondition"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }